import { OrderType } from "@merchstores/shared/components/MerchStore";
import { fetchShopifyOrders, IShopifyOrdersData } from "./ShopifyOrders";
import { OrderStatus } from "./OrderStatus";
import { IOrderCustomer } from "./MerchStoreOrder";
import { IShopifyOrder } from ".";

export interface IMerchStoreIndividualOrder {
  id: string;
  name: string;
  createdAt: string;
  closedAt?: string;
  totalPrice: string;
  totalTax: string;
  totalShippingPrice: string;
  shippingTitle: string;
  status: OrderStatus;
  email: string;
  customer: IOrderCustomer;
  tags: string[];
  itemsCount: number;
}

export async function fetchPendingIndividualOrders(storeCode: string): Promise<Array<IShopifyOrder>>
{
  const pendingIndividualOrdersData = await fetchShopifyOrders({
    storeCode: storeCode,
    orderType: OrderType.INDIVIDUAL,
    closeDate: 'pending',
    sorting: 'dateDesc'
  });

  const pendingIndividualOrders = pendingIndividualOrdersData.orders;

  return pendingIndividualOrders;
}

export async function fetchIndividualOrders(storeCode: string, combinedOrderId: string): Promise<IShopifyOrdersData>
{
  if (combinedOrderId === 'merchstore-pending')
  {
    return fetchShopifyOrders({
      storeCode: storeCode,
      closeDate: 'pending',
      orderType: OrderType.INDIVIDUAL,
      sorting: 'dateDesc'
    });
  }

  return fetchShopifyOrders({
    storeCode: storeCode,
    combinedOrderId: combinedOrderId,
    orderType: OrderType.INDIVIDUAL,
    sorting: 'dateDesc'
  });
}
